export default __webpack_public_path__ + "static/1601-88e1464c6d5f3c48d3164a653a31d433.gif";